import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Classical_Antiquity_-_Ancient_Greece.png';

function HistoryPageGreeceGo() {
  return (
    <QuizPage
      title="History: Ancient Greece"
      subTopic="Ancient Greece"
      backgroundImage={historyImage}
      returnPath="/History-Ancient-Greece"
    />
  );
}

export default HistoryPageGreeceGo;   


